module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADzSURBVFiF7ZZBjsMgEAS7R/uvkGcgPwb7MZhnhLysc4kjtCsOHhxpD9TFwtKUmrnQBIB93x8AAs5RJT2XZVmPH6WUICmddUnazKz+5JxXRxAACCQDgE8YSQ+HBySTpJuRTB7BQSkltN8Bgg0KLmWG6THD9JhheswwPWaYHgagjghijEPzDdVIbt5pSZ/ZGGNtzw7Xk8fB8+r2tnLWdeF2r8O9mau20rqYc169BUvS1tbOERfJu5G8eYbfgtRuYqQ1SkoGX//9w6yd32SG6THD9JhheswwPf5dmDoiOJ7/0YIkaTOSm7MuVpL330L4LlfNrL4A+VlroxpK9k0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/icon/icon-module.png
// module id = 147
// module chunks = 63